import { Component, HostBinding, Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { MapService } from 'src/app/services/map.service';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss'],
})
export class TestComponent implements OnInit {
  isMapLoading$: Observable<boolean>;
  isFullScreenView$: Observable<boolean>;
  constructor(private mapService: MapService) {
    this.isMapLoading$ = this.mapService.isLoading$;
  }
  ngOnInit(): void {
    this.isFullScreenView$ = this.mapService.fullScreenView$;
  }
  @HostBinding('class') class = 'modus-content-rows';

  // TODO refactor to move APIKey to environment
}
